export const APIPATHENV = "http://localhost:5000/api/v1/"; export const RAZORPAYKEY = "rzp_live_FWFbpTNvqGumEJ";
export const URL = "https://www.ngxtechnologies.com/"
